import { render, staticRenderFns } from "./BirthdayInput.vue?vue&type=template&id=2a954753&scoped=true"
import script from "./BirthdayInput.vue?vue&type=script&lang=js"
export * from "./BirthdayInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a954753",
  null
  
)

export default component.exports